import React from 'react'
import { useParams } from 'react-router-dom'
import cx from 'classnames'

import useSchools from '../../hooks/useSchools'
import useEnrolledSchools from '../../hooks/useEnrolledSchools'
import Navbar from '../shared/SchoolNavbar'
import Content from './Content'
import Loader from '../shared/Loader'

import '../../scss/components/Courses.scss'

export default () => {
	const { slug } = useParams()
	
	const schools = useSchools()
	const enrolledSchools = useEnrolledSchools()
	
	const school = schools.find(school => school.slug === slug) ?? enrolledSchools.find(school => school.slug === slug)
	
	return (
		<div className={cx('courses', { loading: !school })}>
			{school
				? (
					<>
						<Navbar school={school} />
						<Content school={school} />
					</>
				)
				: <Loader size="24px" thickness="4px" color="#63b3ed" />
			}
		</div>
	)
}
